import React from 'react'
import { AccountMember } from '@/javascript/domain/entities/account-member'
import AutocompleteSingleFetchInput from '@/javascript/presentation/components/inputs/autocomplete-single-fetch-input'
import LabelPopover from '@/javascript/presentation/components/inputs/label-popover'
import { useRoutingContext } from '../../hooks/use-routing-context'
import AccountMemberSelectionTable from './account-member-selection-table'

const MEMBER_LIMIT = 100

const AccountMemberSelectionInput: React.FC = () => {
  const {
    selectedMembers, setSelectedMembers, setMemberConfigurations, loadAccountMemberList, accountInfo
  } = useRoutingContext()

  const addMember = (member: AccountMember) => {
    if (selectedMembers.some(m => m.id === member.id)) return
    setMemberConfigurations(prev => ({
      ...prev,
      [member.id]: {
        initial: { latitude: accountInfo.latitude, longitude: accountInfo.longitude, address: accountInfo.address },
        final: { latitude: accountInfo.latitude, longitude: accountInfo.longitude, address: accountInfo.address },
        workLimit: null,
      },
    }))
    setSelectedMembers(prev => [...prev, member])
  }

  return (
    <>
      <AutocompleteSingleFetchInput
        label={<LabelPopover label="Executores" tooltipText="O sistema irá respeitar as permissões dos formulários para distribuir as atividades aos executores." />}
        fetchOptions={(text) => loadAccountMemberList.load({ searchText: text, onlyActive: true })}
        selectedItems={selectedMembers}
        onSelect={addMember}
        getOptionLabel={(m) => m.user.completeData}
        getOptionKey={(m) => m.id}
        limitReached={selectedMembers.length >= MEMBER_LIMIT}
        limitTooltip="O limite máximo de executores selecionadas foi atingido."
        data-testid="account-member-selection-input"
      />
      
      <AccountMemberSelectionTable />
    </>
  )
}

export default AccountMemberSelectionInput
